<template>
	<v-container>
		<v-card-actions>
			<v-spacer />
			<action-menu
				entity="resource"
				:title="$tc('entities.resource.title', 1)"
				:data="value"
			/>
		</v-card-actions>
		<v-tabs v-model="tab" vertical>
			<v-tab key="general">{{ $t("general") }}</v-tab>
			<v-tab key="CustomFields">{{ $t("customFields") }}</v-tab>
			<v-tab key="variable">{{ $t("variables") }}</v-tab>
			<v-tabs-items v-model="tab">
				<v-tab-item key="general">
					<v-form ref="form" v-model="valid">
						<v-text-field
							:label="$t('entities.resource.props.code')"
							v-model="value.code"
							:rules="$isRequiredRule"
							clearable
						></v-text-field>
						<v-text-field
							:label="$t('entities.resource.props.seq')"
							v-model="value.seq"
							:rules="$isRequiredRule"
							clearable
						></v-text-field>
						<v-select
							:label="$t('entities.resource.props.environmentId')"
							v-model="value.environmentId"
							:items="environments"
							item-text="description"
							item-value="id"
							:rules="$isRequiredRule"
							clearable
						></v-select>
						<v-select
							:label="$t('entities.resource.props.stageTypeId')"
							v-model="value.stageTypeId"
							:items="stageTypes"
							item-text="description"
							item-value="id"
							clearable
						></v-select>
						<v-text-field
							:label="$t('entities.resource.props.description')"
							v-model="value.description"
							:rules="$isRequiredRule"
							clearable
						></v-text-field>

						<v-text-field
							:label="$t('entities.resource.props.type')"
							v-model="value.type"
							clearable
						></v-text-field>
						<v-text-field
							:label="$t('entities.resource.props.sector')"
							:rules="$isRequiredRule"
							v-model="value.sector"
							clearable
						></v-text-field>
						<v-autocomplete
							:label="$t('entities.resource.props.resourceRestIds')"
							:items="resourcesComp"
							v-model="value.resourceRestIds"
							item-text="description"
							item-value="id"
							clearable
							multiple
							chips
							@input="searchResorce"
						></v-autocomplete>
						<auto-complete-entity
							ref="printer"
							v-model="value.printerId"
							entityApi="printer"
							:itemPreSelected="printerSelected"
							itemText="description"
							itemValue="id"
							:label="$t('entities.resource.props.printerId')"
							prependIcon="mdi-find-replace"
						/>
						<auto-complete-entity
							ref="report"
							v-model="value.reportId"
							entityApi="report"
							:itemPreSelected="selectedReport"
							fieldApi="description"
							itemText="description"
							itemValue="id"
							:label="$t('entities.regType.props.reportId')"
							prependIcon="mdi-find-replace"
						/>
					</v-form>
				</v-tab-item>
				<v-tab-item key="CustomFields" eager>
					<entity-field-custom-autoform
						v-model="value"
						entity="Resource"
					></entity-field-custom-autoform>
				</v-tab-item>
				<v-tab-item key="variable" eager>
					<variable-table 
						:stageTypes="stageTypes.filter(type => type.id == value.stageTypeId)[0]"
						v-model="value.Variables"
						:variables="value.Variables || []"
						@variables="handleVariables"
					/>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</v-container>
</template>

<script>
	import printerService from "../../../services/printerService";
	import variableTable from './variableTable.vue';
	export default {
		components: { variableTable },
		props: {
			value: {
				default() {
					return {
						environmentId: "",
						code: "",
						description: "",
						sector: "",
						type: "",
						resourceRestIds: [],
						Variables: []
					};
				},
			},
			itemSelected: {
				default() {
					return [];
				},
			},
			environments: {
				default() {
					return [];
				},
			},
			resources: {
				default() {
					return [];
				},
			},
			stageTypes: {
				default() {
					return [];
				},
			},
		},
		watch: {
			async value() {
				this.printerSelected = null;
				await this.getPrinter();
			},

			itemSelected: {
				handler(value){
					console.log("SELECTED >>> ", value)
					this.value.Variables = value.Variables || []
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			resourcesComp() {
				if (!this.resources) return [];
				return this.resources.filter((r) => r.id != this.value.id);
			},
		},
		data() {
			return {
				tab: null,
				valid: false,
				printerSelected: null,
			};
		},
		methods: {
			async getPrinter() {
				if (!this.value.printerId) return;
				const res = await printerService.getById(this.value.printerId);
				if (res.success) this.printerSelected = res.data;
			},
			isValid() {
				return this.$refs.form.validate();
			},

			handleVariables(e){
				this.value.Variables = e
			},

			searchResorce(search){
				this.$emit('search', search)
			}
		},
		async mounted() {
			await this.getPrinter();
		},
	};
</script>
